<div class="row mt-4 mb-4">
  <div *ngFor="let item of items" class="col-6 col-md-4 col-lg-3 mb-2">
    <ng-template libCustomHost></ng-template>
  </div>
</div>
